// Symbole und Farben der Mieterportal-Kategorien (Prototyp Mieterportal: KAT).
import { DotsThreeCircle, Door, Drop, Lightning, Stairs, ThermometerHot, type Icon } from '@phosphor-icons/react';
import type { PortalFarbe } from '../../components/portal/bausteine';
import type { KategorieKey } from '../../lib/portal/mieter';

export const KATEGORIE_STIL: Record<KategorieKey, { icon: Icon; farbe: PortalFarbe }> = {
  heizung: { icon: ThermometerHot, farbe: 'heizung' },
  wasser: { icon: Drop, farbe: 'wasser' },
  strom: { icon: Lightning, farbe: 'strom' },
  tueren: { icon: Door, farbe: 'tueren' },
  gemein: { icon: Stairs, farbe: 'gemein' },
  sonst: { icon: DotsThreeCircle, farbe: 'sonst' },
};
